"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileCard = void 0;
var _litHtml = require("lit-html");
require("./styles/ProfileCard.css");
var _addMeToYourFriends = require("./addMeToYourFriends");
var _QRCodeCard = require("./QRCodeCard");
const ProfileCard = ({
  name,
  imageSrc,
  introduction,
  location,
  pronouns,
  highlightColor,
  backgroundColor
}, context, subject) => {
  return (0, _litHtml.html)`
    <article class="profileCard" aria-labelledby="profile-name">
      <h2 id="profile-name" class="sr-only">${name}</h2>
      <header class="header flex-column-center mb-md" aria-label="Profile information">
        ${Image(imageSrc, name)}
      </header>
      
      <section class="intro text-center" aria-label="About">
        ${Line(introduction, '', 'About')}
        ${Line(location, '🌐', 'Location')}
        ${Line(pronouns, '', 'Pronouns')}
      </section>
      
      <section class="buttonSection text-center" aria-label="Actions">
        ${(0, _addMeToYourFriends.addMeToYourFriendsDiv)(subject, context)}
      </section>
      
      <div class="qrCodeSection section-centered">
        ${(0, _QRCodeCard.QRCodeCard)(highlightColor, backgroundColor, subject)}
      </div>
    </article>
  `;
};
exports.ProfileCard = ProfileCard;
const Line = (value, prefix = _litHtml.nothing, label = '') => value ? (0, _litHtml.html)`
    <div class="details" role="text" ${label ? `aria-label="${label}: ${value}"` : ''}>
      ${prefix} ${value}
    </div>
  ` : _litHtml.nothing;
const Image = (src, alt) => src ? (0, _litHtml.html)`
        <img
          class="image"
          src=${src}
          alt="Profile photo of ${alt}"
          width="160"
          height="160"
          loading="eager"
        />
      ` : (0, _litHtml.html)`
        <div class="image-alt" role="img" aria-label="${alt}" tabindex="0">
          ${alt}
        </div>
      `;